import * as React from 'react';
import s from './ProductRibbon.scss';
import {IProvidedGlobalProps, withGlobalProps} from '../../providers/globalPropsProvider';

export enum DataHook {
  Root = 'product-widget-ribbon',
}

export type IProductRibbonProps = IProvidedGlobalProps;

class ProductRibbonComp extends React.Component<IProductRibbonProps> {
  public render(): React.ReactNode {
    const {
      globals: {product},
    } = this.props;
    return (
      <span data-hook={DataHook.Root} aria-hidden="true" className={s.productRibbon}>
        {product.ribbon}
      </span>
    );
  }
}

export const ProductRibbon = withGlobalProps(ProductRibbonComp);
